export default __webpack_public_path__ + "static/media/330_business03-en-web.26356375.png";